import ChatContainer from "@/components/ChatContainer/chatContainer.component";
import { Button } from "@/shadcn/components/ui/button";
import { ArrowRightFromLine } from "lucide-react";
import React from "react";

type ChatMultipleSearchResultsProps = {
  taskIDs: number[];
  closeChat: () => void;
};

const ChatMultipleSearchResults: React.FC<ChatMultipleSearchResultsProps> = ({
  taskIDs,
  closeChat,
}) => {
  return (
    <div className="w-full h-full flex flex-col overflow-hidden p-5">
      <div className="flex justify-between items-center">
        <div className="w-full">
          <h1 className="font-bold text-center text-2xl">Search Chat</h1>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="btn btn-primary rounded-sm"
          onClick={closeChat}
        >
          <ArrowRightFromLine className="w-5 h-5" />
        </Button>
      </div>
      {taskIDs.length > 0 ? (
        <ChatContainer chatID={taskIDs} type="multipleResultsChat" />
      ) : (
        <div className="text-left text-xl font-bold">No tasks selected</div>
      )}
    </div>
  );
};

export default ChatMultipleSearchResults;
